export default __webpack_public_path__ + "static/media/menu.feba03ca.pdf";